function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    // Swap
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}

document.addEventListener('DOMContentLoaded', function () {
  const MAX_CHARS = 6;

  document.querySelectorAll('[data-button-glitch-effect]').forEach(button => {
    const labelSelector = button.getAttribute('data-button-glitch-effect') || '.btn__label';
    const labelEl = button.querySelector(labelSelector);
    const text = labelEl.textContent.trim();

    // Split text into chars
    labelEl.innerHTML = '';
    [...text].forEach((char, i) => {
      const span = document.createElement('span');
      span.classList.add('char');
      span.textContent = char;
      span.dataset.char = char;
      labelEl.appendChild(span);
    });

    const chars = Array.from(labelEl.querySelectorAll('.char'));
    let glitchQueue = [];
    let index = 0;
    let interval;

    const startGlitch = () => {
      glitchQueue = shuffle(chars).slice(0, MAX_CHARS); // pick random chars
      index = 0;

      interval = setInterval(() => {
        if (index > 0 && index <= glitchQueue.length)
          glitchQueue[index - 1].classList.remove('--glitching');

        if (index >= glitchQueue.length) {
          clearInterval(interval);
          return;
        }

        glitchQueue[index].classList.add('--glitching');
        index++;
      }, 100);
    };

    const stopGlitch = () => {
      clearInterval(interval);
      chars.forEach(c => c.classList.remove('--glitching'));
    };

    button.addEventListener('mouseenter', startGlitch);
    button.addEventListener('mouseleave', stopGlitch);
  });
});
